<template>
    <loader v-if="loading"></loader>

    <div class="screen" v-else>
        <div class="requests">
            <div v-for="travel_offer in all_requests" v-bind:key="travel_offer.userEmail"
                 class="request">
                <span>{{travel_offer.userEmail}}</span>
                <div class="request-footer">
                    <div style="display: flex; justify-content: space-between; width: 100%">
                        Location:
                        {{travel_offer.location}}
                    </div>
                    <div style="display: flex; justify-content: space-between; width: 100%">
                        Date:
                        {{formatDate(travel_offer.requestDate)}}
                    </div>
                    <div style="display: flex; justify-content: space-between; width: 100%">
                        Taxi:
                        {{travel_offer.taxiTypeName}}
                    </div>
                </div>
                <div style="display: flex; justify-content: flex-end;width: 100%">
                    <i class="el-icon-delete" style="color: red"></i>
                </div>
            </div>

        </div>


    </div>
</template>

<script>
    import TaxiService from '@/common/services/taxi.service'
    import mutations from "@/store/mutation_types";
    import Loader from "../../common/components/loader";
    import {mapMutations, mapState} from "vuex";
    import moment from "moment";

    export default {
        name: 'Requests',
        components: {Loader},
        data() {
            return {
                loading: false
            }
        },
        methods: {
            ...mapMutations(['SET_TAXI_REQUESTS']),
            formatDate(date) {
                return moment(date).format('DD MMM, YYYY HH:mm')
            }
        },
        computed: {
            ...mapState({
                user: state => state.user,
                all_requests: state => state.taxi_requests
            }),

        },
        beforeMount() {
            this.loading = true;
            TaxiService.getRequests(this.user.user_email).then(response => {
                this[mutations.SET_TAXI_REQUESTS](response.data)
            }).catch(error => {
                this.$notify.error({
                    title: `Failed to travels`,
                    message: error.response.data.message
                });
            }).finally(() => this.loading = false)

        }
    }
</script>

<style scoped lang="scss">


    .request {
        border: 1px solid whitesmoke;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
        border-radius: 5px;
        cursor: pointer;
        -webkit-box-shadow: 0 0 5px #c7c1c1;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px;
        flex-direction: column;
        margin: 10px;
        width: 23%;
        text-align: left;

        .request-footer {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }

        span {
            font-weight: 700;
            padding: 5px 0;
        }
    }


    .requests {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        /*justify-content: center;*/
        /*grid-area: eventContainer;*/
        /*display: grid;*/
        /*grid-template-columns: 1fr 1fr 1fr 1fr;*/
        /*text-align: center;*/
        /*grid-gap: 20px;*/
        /*margin: 20px;*/
    }


    .eventScheduler {
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
        bottom: 0;
        grid-area: eventScheduler;
        background-color: white;
        min-height: 52vmin;
        margin: 0 20px;
        margin-bottom: 10px;
        border-radius: 5px;
        max-width: 100%;
        overflow: hidden;
        -webkit-box-shadow: 0 0 5px #c7c1c1
    }


    .screen {
        display: grid;
        width: 100%;
        padding: 20px;
        /*height: 100%;*/
        /*height: 100vh;*/
        /*grid-gap: 10px;*/
    }
</style>
